import {createFileRoute, Navigate} from "@tanstack/react-router";
import {useMountedTruck} from "../../../driver/mountedTruck.ts";
import {SuspenseDialog} from "../../../components/SuspenseDialog.tsx";

function DriverTruckPage() {
    const mountedTruckTqrv        = useMountedTruck();
    const mountedTruck = mountedTruckTqrv.data
    if (!mountedTruckTqrv.isSuccess) {
        return <SuspenseDialog message="finding mounted truck"/>;
    }
    if (!mountedTruck) {
        throw new Error("no mounted truck");
    }
    return <Navigate to="/truck/$id/drive" params={{id: mountedTruck.id}}/>;

    // const {t} = useTranslation();
    // const mama = useMothership();
    // const searchParams = Route.useSearch();
    // const {data: mountedTruckData, isSuccess: isMountedTruckSuccess}
    //     = useMountedTruck({});
    // const mountedTruck = mountedTruckData?.truck;
    // const mountedTruckId = mountedTruck?.id ?? TQDEADBEEF;
    // const [plate, setPlate]
    //     = useState<string>("");
    // const {data: fromPlateTqrv}
    //     = useQuery({...peekTruckByPlateTqo(mama, {plate: plate}), enabled: !!plate});
    // const idFromPlate = fromPlateTqrv?.truck?.id;
    // const {data: lastTriplegData, isSuccess: isLastTriplegSuccess}
    //     = useLastTriplegForTruck({
    //     truckId: mountedTruckId,
    //     enabled: isMountedTruckSuccess && mountedTruckId !== TQDEADBEEF,
    // });
    // const lastTripleg = lastTriplegData ?? undefined;
    // const {data: lastTriplegStatus, isSuccess: isLastTriplegStatusSuccess}
    //     = useTriplegStatus({tripleg: lastTripleg});
    // const prevTriplegStatusCode = usePrevious(lastTriplegStatus?.code);
    // const navigate = useNavigate();
    //
    // const actionZone = useMemo(() => {
    //     switch (lastTriplegStatus?.code) {
    //         case undefined:
    //         case TriplegStatusCode.UNKNOWN:
    //             return null;
    //
    //         case TriplegStatusCode.COMPLETE:
    //             return <Stack direction="column" spacing={3} sx={{alignItems: "center"}}>
    //                 <Stack direction="row" spacing={1.8} sx={{alignItems: "center"}}>
    //                     <VenueCapsule venue={lastTripleg!.destination}/>
    //                 </Stack>
    //                 <Button color="primary" sx={{px: 3, py: 1.5}}
    //                         onClick={() => {
    //                             void navigate({
    //                                 to: venueRoute.to,
    //                                 params: {id: lastTripleg!.destination.id}
    //                             });
    //                         }}>
    //                     {t("driver.gotoServiceVenue")}
    //                 </Button>
    //             </Stack>;
    //
    //         case TriplegStatusCode.EN_ROUTE:
    //             return <Stack direction="column" spacing={3} sx={{alignItems: "center"}}>
    //                 <Stack direction="row" spacing={1.8} sx={{alignItems: "center"}}>
    //                     <VenueCapsule venue={lastTripleg!.destination}/>
    //                     {t("driver.enRouteTo")}
    //                 </Stack>
    //                 <ArriveButton depth="brief" truckId={mountedTruckId}
    //                               sx={actionZoneSx} color="primary"/>
    //             </Stack>;
    //
    //         case TriplegStatusCode.AWAITING_ADMISSION:
    //             return <Stack direction="column" spacing={3} sx={{alignItems: "center"}}>
    //                 <Stack direction="row" spacing={1.8} sx={{alignItems: "center"}}>
    //                     <VenueCapsule venue={lastTripleg!.destination}/>
    //                     {t("driver.enRouteTo")}
    //                 </Stack>
    //                 <Typography level="h3" color="primary">
    //                     {t("driver.awaitingAdmission")}
    //                 </Typography>
    //             </Stack>;
    //
    //         default:
    //             return <Alert color="danger" variant="soft">
    //                 {t("unknownError")}
    //             </Alert>;
    //     }
    // }, [lastTripleg, lastTriplegStatus?.code, mountedTruckId, navigate, t]);
    //
    // useEffect(() => {
    //     // if we have just been admitted, switch to cargo view on the assumption that
    //     // the next thing the driver will want to do is unload stuff
    //     if (prevTriplegStatusCode === TriplegStatusCode.AWAITING_ADMISSION
    //         && lastTriplegStatus?.code === TriplegStatusCode.COMPLETE
    //         && searchParams.facet === "timeline") {
    //         void navigate({
    //             to: Route.to,
    //             search: {...searchParams, facet: "cargo"},
    //         });
    //     }
    // }, [lastTriplegStatus?.code, navigate, prevTriplegStatusCode, searchParams]);
    //
    //
    // if (!isMountedTruckSuccess
    //     || (mountedTruckId !== TQDEADBEEF &&
    //         (!isLastTriplegSuccess ||
    //             (!!lastTripleg && !isLastTriplegStatusSuccess)))) {
    //     return <SuspenseDialog message="driver truck"/>;
    // }
    //
    // return <Sheet>
    //     <Stack direction="column" spacing={2}>
    //         <Stack direction="row" sx={{alignItems: "center", px: 4, pr: 8, py: 0.6}}>
    //             {mountedTruck
    //                 ? <>
    //                     <TruckCapsule truck={mountedTruck}/>
    //                     <Box sx={{flex: 1}}/>
    //                     <TruckMountButton truckId={mountedTruck.id}/>
    //                 </>
    //                 : <>
    //                     <FormControl>
    //                         <FormLabel>{t("truckPlateLabel")}</FormLabel>
    //                         <Input value={plate}
    //                                onChange={(evt) => {
    //                                    setPlate(evt.target.value);
    //                                }}/>
    //                     </FormControl>
    //                     <Box sx={{flex: 1}}/>
    //                     <TruckMountButton truckId={idFromPlate}/>
    //                 </>}
    //         </Stack>
    //         {actionZone
    //             ? <>
    //                 <Divider sx={{fontSize: "sm"}}>{t("driver.currentTriplegStatusSubheader")}</Divider>
    //                 <Stack direction="column" sx={{alignItems: "center", justifyContent: "center"}}>
    //                     {actionZone}
    //                 </Stack>
    //             </>
    //             : null}
    //         {mountedTruck
    //             ? <TruckDualView truckId={mountedTruck.id} facet={searchParams.facet}
    //                              setFacet={(nv) => {
    //                                  void navigate({
    //                                      to: Route.to,
    //                                      params: {},
    //                                      search: {...searchParams, facet: nv},
    //                                      replace: true,
    //                                  });
    //                              }}
    //                              asof={searchParams.asof}
    //                              setAsof={newAsof => {
    //                                  void navigate({
    //                                      to: Route.to,
    //                                      params: {},
    //                                      search: {...searchParams, asof: newAsof ? new Date(newAsof) : undefined},
    //                                      replace: true,
    //                                  });
    //                              }}
    //             />
    //             : null}
    //     </Stack>
    // </Sheet>
}

export const Route = createFileRoute("/_auth/driver/my-truck")({
    component: DriverTruckPage,
});
